import React from "react";
import "@/App.css";
import { WorkbookLayout } from "@/components/WorkbookLayout";
import { WorkbookProvider } from "@/context/WorkbookContext";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { LoginPage } from "@/pages/LoginPage";
import { AdminDashboard } from "@/pages/AdminDashboard";
import { AllyRegisterPage } from "@/pages/AllyRegisterPage";
import { AllyDashboard } from "@/pages/AllyDashboard";
import { ResetPasswordPage } from "@/pages/ResetPasswordPage";

function AppContent() {
  var auth = useAuth();
  var path = window.location.pathname.replace(/\/$/, '');

  // Admin console route (independent of workbook auth)
  if (path === '/admin') {
    return <AdminDashboard />;
  }

  // Ally invitation acceptance (public)
  if (path.indexOf('/ally-invite/') === 0) {
    var inviteToken = path.substring('/ally-invite/'.length);
    return <AllyRegisterPage token={inviteToken} />;
  }

  // Self-service password reset (public)
  if (path.indexOf('/reset-password/') === 0) {
    var resetToken = path.substring('/reset-password/'.length);
    return <ResetPasswordPage token={resetToken} />;
  }
  
  // Show loading spinner while checking auth
  if (auth.loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    );
  }
  
  // Show login page if not authenticated
  if (!auth.isAuthenticated) {
    return <LoginPage />;
  }

  // Allies get a read-only check-in dashboard
  if (auth.user && auth.user.role === 'ally') {
    return <AllyDashboard />;
  }

  // Show workbook if authenticated
  return (
    <WorkbookProvider>
      <WorkbookLayout />
    </WorkbookProvider>
  );
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  );
}

export default App;
